import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMVariantButton } from '../../ui-elements/MyMButton';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import ValidatableAttachmentFiles from '../../ui-parts/ValidatableAttachmentFiles';
import ValidatableDatePicker from '../../ui-parts/ValidatableDatePicker';
import ValidatableDropDownList from '../../ui-parts/ValidatableDropDownList';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { useMediaQuery } from '@mui/material';
import ValidatableCheckBoxDropDownList from '../../ui-parts/ValidatableCheckBoxDropDownList';


/** MyMine Version2.1 RequestBoard画面新規追加
* RequestBoard Page Component
*/
export const RequestBoard = (props) => {
  // 変数・State
  const { authUser, handleModalClose, callbackUpdateRequest } = props;
  const screenId = 'MyM704';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const [requestCategoryList, setRequestCategoryList] = useState(null);
  const [targetProductCategoryList, setTargetProductCategoryList] = useState(null);
  const [targetProductList, setTargetProductList] = useState([]);
  const [selectTargetProduct, setSelectTargetProduct] = useState([]);
  const [selectTargetProductCategory, setSelectTargetProductCategory] = useState(null);
  const [detail, setDetail] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { handleSubmit, control, formState, clearErrors, trigger, setValue } = useForm({
    mode: 'onSubmit',
  })
  const [files, setFiles] = useState([]);
  const validationRules = useValidationRules();
  var deadlineFromDate = new Date();
  deadlineFromDate.setDate(deadlineFromDate.getDate() + 5);
  const isSmallScreen = useMediaQuery('(max-width: 600px)'); // 600px以下の画面幅を検出

  // スタイル
  const theme = useTheme();

  const myMRequestBoardButtonStyle = {
    border: '2px solid #777777',
    borderRadius: '10px',
    fontSize: isSmallScreen ? '0.8rem' : '1rem',
    color: '#000000',
    margin: isSmallScreen ? '5px' : '10px', 
    width: isSmallScreen ? '150px' : '190px',
    backgroundColor: '#fff',
    ':hover': {
      backgroundColor: '#fff',
    },
  };

  /**
   * Submitクリック時処理
   * @param {any} data
   * @param {any} e
   */
  const onClickBtnSubmit = async (data, e) => {
    if (window.confirm(messageList.MyM_MSG_I_0139)) {
      const formData = new FormData();
      formData.append(`Name`, data.name);
      formData.append(`Email`, data.userId);
      formData.append(`TargetProductCategory`, data.targetProductCategory);
      selectTargetProduct.forEach((value, i) => { formData.append(`TargetProduct`, value); })
      formData.append(`RequestCategory`, data.requestCategory);
      formData.append(`Title`, data.title);
      formData.append(`Detail`, data.detail);
      if (data.deadlineDate !== undefined) {
        formData.append(`DeadlineDate`, data.deadlineDate.$d.toLocaleString());
      }
      files.forEach((file, i) => { formData.append(`AttachmentFile`, file); })

      const callbackSuccess = (result) => {
        setIsLoading(false);
        setIsSubmitted(true);
      }

      const callbackFailed = () => {
        setIsLoading(false);
      }

      //POST
      apiRequest.requestForm('api/request/submit', 'POST', callbackSuccess, callbackFailed, formData);

      setIsLoading(true);
    }
  }

  /** Submit後のBackボタンクリック時処理  */
  const onClickAfterBack = () => {
    handleModalClose();
    callbackUpdateRequest();
  }

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  // ページロード時処理
  useEffect(() => {
    const callbackPageLoadContext = (result) => {
      setRequestCategoryList(result.RequestCategoryList);
      setTargetProductCategoryList(result.TargetProductCategoryList);
      setTargetProductList(result.TargetProductList);
      setIsLoading(false);
    }

    const callbackFailed = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }

    apiRequest.requestJson('api/request/load', 'GET', callbackPageLoadContext, callbackFailed)
    setIsLoading(true);
  }, []);

  if (!requestCategoryList)
    return <MyMProgress />

  return (
    <Box sx={{ maxHeight: '91vh', overflow: 'auto' }}>
      {isLoading && <MyMProgress />}
      <OutlinedCustomCard>
        <CardHeader
          sx={{ display: 'flex', background: theme.palette.background.secondary, height: '105px' }}
          titleTypographyProps={{ align: 'center' }}
          title={isSmallScreen ?
            <MyMLabel fontSize='1.5rem' sx={{ color: 'white' }}>{controlSettings.LabelList.lblRequestBoard}</MyMLabel>
            :
            <Grid container>
              <Grid item xs={12}><MyMLabel fontSize='1.5rem' sx={{ color: 'white' }}>{controlSettings.LabelList.lblRequestBoard}</MyMLabel></Grid>
              <Grid item xs={12} sx={{ minHeight: '25px' }}></Grid>
              <Grid item xs={12}><MyMLabel fontSize='1rem' sx={{ color: 'white' }}>{controlSettings.LabelList.lblRequestBoard1}</MyMLabel></Grid>
            </Grid>
          }
        />
        {isSubmitted === false ?
          <CardContent sx={{ backgroundColor: 'rgba(5, 5, 10, 0.04)', '.MuiInputBase-root': { backgroundColor: 'white' } }}>
            <Grid container>
              <Grid item lg={5.7} xs={12} className='mt-3'>
                <ValidatableTextBox
                  control={control}
                  name="name"
                  defaultValue={`${authUser?.FirstName ?? ''} ${authUser?.LastName ?? ''}`.trim()}
                  formState={formState}
                  maxLength={110}
                  rules={
                    {
                      ...validationRules.required(),
                      ...validationRules.maxLength(110),
                    }
                  }
                  InputProps={{ startAdornment: <InputAdornment position="start">{controlSettings.LabelList.lblName}</InputAdornment> }}
                />
              </Grid>
              <Grid item lg={0.6}></Grid>
              <Grid item lg={5.7} xs={12} className='mt-3'>
                <ValidatableTextBox
                  control={control}
                  name="userId"
                  defaultValue={authUser.UserId}
                  formState={formState}
                  maxLength={256}
                  rules={
                    {
                      ...validationRules.required(),
                      ...validationRules.maxLength(256),
                      ...validationRules.mailAddress(),
                    }
                  }
                  InputProps={{ startAdornment: <InputAdornment position="start">{controlSettings.LabelList.lblEmail}</InputAdornment> }}
                />
              </Grid>
              
              <Grid item xs={12} className='mt-3'>
                {/*  Target Product Category*/}
                <ValidatableDropDownList
                  maxWidth
                  control={control}
                  formState={formState}
                  needsBlank={true}
                  onChange={e => {
                    const newCategory = e.target.value;
                    setSelectTargetProductCategory(newCategory);
                    setSelectTargetProduct([]); // state
                    setValue('selectTargetProduct', []); // form value
                    if (formState.isSubmitted) {
                      trigger('selectTargetProduct');
                    }
                  }}

                  name="targetProductCategory"
                  placeholder={controlSettings.LabelList.lblTargetProductCategory}
                  options={targetProductCategoryList}
                  rules={{ ...validationRules.required(), }}
                  style={{ background: 'white' }}
                />
              </Grid>
              <Grid item xs={12} className={`mt-3 ${!selectTargetProductCategory && 'd-none'}`}>
                {/*  Target Product*/}
                
                <ValidatableCheckBoxDropDownList
                  key={selectTargetProductCategory}
                  maxWidth
                  multiple
                  control={control}
                  formState={formState}
                  needsBlank={false}
                  onChange={async (value) => {
                    await setSelectTargetProduct(value);
                   formState.isSubmitted && await trigger('selectTargetProduct');
                  }}
                  name="selectTargetProduct"
                  placeholder={controlSettings.LabelList.lblTargetProductTitle}
                  value={selectTargetProduct ?? []}
                  options={targetProductList.filter(x => x.TargetProductCategoryId === selectTargetProductCategory).map((list) => {
                    return {
                      value: list.TargetProductId,
                      text: list.TargetProductName,
                    }
                  })}
                  rules={{ ...validationRules.listRequired(selectTargetProduct, null, false), }}
                  style={{ background: 'white' }}
                />
              </Grid>
              <Grid item xs={12} className='mt-3'>
                {/*  Request Category*/}
                <ValidatableDropDownList
                  maxWidth
                  control={control}
                  formState={formState}
                  needsBlank={true}
                  name="requestCategory"
                  placeholder={controlSettings.LabelList.lblRequestCategory}
                  options={requestCategoryList}
                  rules={{ ...validationRules.required(), }}
                  style={{ background: 'white' }}
                />
              </Grid>
              <Grid item xs={12} className='mt-3'>
                <ValidatableTextBox
                  fullWidth
                  control={control}
                  defaultValue=""
                  name="title"
                  formState={formState}
                  variant="outlined"
                  maxLength={200}
                  label={
                    <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                      {controlSettings.LabelList.lblTitle}
                    </span>
                  }
                  rules={{
                    ...validationRules.required(),
                    ...validationRules.maxLength(200),
                  }}
                />
              </Grid>


              <Grid item xs={12} className='mt-3'>
                <Stack>
                  <MyMVariantLabel variant="caption" className='d-flex justify-content-end'>{detail?.length ?? 0} / {screenSettings.MaxTextLength}</MyMVariantLabel>
                </Stack>
                <ValidatableTextBox
                  multiline
                  rows={14}
                  height='100%'
                  control={control}
                  name="detail"
                  maxLength={screenSettings.MaxTextLength}
                  formState={formState}
                  rules={
                    {
                      ...validationRules.required(),
                      ...validationRules.maxLength(screenSettings.MaxTextLength),
                    }
                  }
                  placeholder={controlSettings.LabelList.lblDetail}
                  onChange={(e) => { setDetail(e.target.value) }}

                />
              </Grid>

              <Grid item xs={12} className='mt-3'>
                <ValidatableAttachmentFiles
                  controlSettings={controlSettings}
                  messageList={messageList}
                  control={control}
                  files={files}
                  setFiles={setFiles}
                  clearErrors={clearErrors}
                  formState={formState}
                  trigger={trigger}
                  fileSizeValidMessageKey='MyM_MSG_E_0013'
                  allowFileSizeZero={false} // ファイルサイズ:0を許容しない
                  allowDuplicateFileName={false} // 重複ファイル名を許容しない
                />
              </Grid>
              <Grid container spacing={isSmallScreen ? 2 : 0}>
                {/* 締切ラベル */}
                <Grid item lg={2} xs={12} className={`d-flex align-items-center ${isSmallScreen ? 'mb-2' : ''}`}>
                  <MyMLabel>{controlSettings.LabelList.lblDeadlineForReply}</MyMLabel>
                </Grid>

                {/* 説明ラベル */}
                <Grid item lg={4} xs={12} className={`d-flex align-items-center ${isSmallScreen ? 'mb-2' : ''}`}>
                  <MyMLabel>{controlSettings.LabelList.lblDeadlineForReplyExplanation}</MyMLabel>
                </Grid>

                {/* 日付ピッカー */}
                <Grid item lg={4} xs={12}>
                  <ValidatableDatePicker
                    name="deadlineDate"
                    control={control}
                    formState={formState}
                    rules={{
                      ...validationRules.date(controlSettings.LabelList.lblDeadlineForReply),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} className='mt-3'>
                <Stack direction='row' justifyContent="flex-end" spacing={3} className='me-3' sx={{ padding: '0 0 10px 0' }}>
                  <MyMVariantButton sx={myMRequestBoardButtonStyle} variant='contained' onClick={handleSubmit(onClickBtnSubmit, onError)} >{controlSettings.LabelList.btnSubmit}</MyMVariantButton>
                  <MyMVariantButton sx={myMRequestBoardButtonStyle} variant='contained' onClick={handleModalClose}>{controlSettings.LabelList.btnBack}</MyMVariantButton>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
          :
          <CardContent>
            <Box className='text-center'>
              <MyMLabel>{controlSettings.LabelList.lblMessage}</MyMLabel>
              <MyMVariantButton sx={myMRequestBoardButtonStyle} variant='contained' onClick={onClickAfterBack}>{controlSettings.LabelList.btnBack}</MyMVariantButton>
            </Box>
          </CardContent>
        }
      </OutlinedCustomCard>
    </Box>
  );
}